import { HeightInterface } from '../../types';
import { stringOrNumberHelper } from './stringOrNumberHelper';

export const heightDecorator = ({ height, maxH, minH }: HeightInterface) => {
	let response = '';
	if (height) {
		response += `height: ${stringOrNumberHelper(height)};`;
	}
	if (maxH) {
		response += `max-height: ${stringOrNumberHelper(maxH)};`;
	}
	if (minH) {
		response += `min-height: ${stringOrNumberHelper(minH)};`;
	}
	return response;
};
